// extracted by mini-css-extract-plugin
export var fileUpload = "_im-1";
export var modalButton = "_im-0";